import { updateObject } from 'utils/updateObject'
import { LOGOUT, SET_AUTH, SET_DATA } from 'modules/Auth/types'

const initialState = {
  loading: true,
  auth: false,
}

const setAuth = (state, { payload }) =>
  updateObject(state, { auth: payload, loading: false })

const logout = (state) => updateObject(state, { auth: false, loading: false })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH:
      return setAuth(state, action)
    case SET_DATA:
      return updateObject(state, action.payload)
    case LOGOUT:
      return logout(state)
    default:
      return state
  }
}

export default reducer
